/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Dimmer, Loader, Modal, Button, Dropdown } from "semantic-ui-react";
import { TextField } from "@mui/material";
import { selectCurrentUserApiToken } from "../slices/currentUser/currentUserSlice";

import axiosInstance from '../functions/axiosInstance';
import server_config from '../ServerConfiguration';

const fevir_node_server_address = server_config["fevir_node_server_address"];

//ATC, ICD9CM, ICD10, ICDO, LOINC, MEDDRA, MESH, NCIT, RXNORM, SNOMEDCT, WHO-ART, and much much more, too many really
const ontologyOptions = [
    { "key": "ATC", "value": "ATC", "text": "ATC" },
    { "key": "ICD-O-3,ICDO,ICD10,ICD10CM,ICD10PCS,ICD9CM", "value": "ICD-O-3,ICDO,ICD10,ICD10CM,ICD10PCS,ICD9CM", "text": "ICD10, etc" },
    { "key": "LOINC", "value": "LOINC", "text": "LOINC" },
    { "key": "MEDDRA", "value": "MEDDRA", "text": "MEDDRA" },
    { "key": "MESH", "value": "MESH", "text": "MESH" },
    { "key": "NCIT", "value": "NCIT", "text": "NCIT" },
    { "key": "RXNORM", "value": "RXNORM", "text": "RXNORM" },
    { "key": "SNOMEDCT", "value": "SNOMEDCT", "text": "SNOMED CT" },
    { "key": "WHO-ART", "value": "WHO-ART", "text": "WHO-ART" }
];


//I decided to write this function on the client-side instead of server-side so that the API call will be coming from the client's IP Address instead of a bunch of calls with different API Keys all coming from our server
const bioPortalSearch = async (bioPortalApiKey, searchStringState, selectedOntologies = []) => {

    if (!searchStringState || !bioPortalApiKey) { return; }
    try {
        //if (limitSnomed) { selectedOntologies.push('SNOMEDCT'); }
        //if (limitLoinc) { selectedOntologies.push('LOINC'); }
        //if (limitMesh) { selectedOntologies.push('MESH'); }

        const queryParams = {
            q: searchStringState,
            display_context: "false", //we don't use the context  //@context": {}
            include: "prefLabel",    //Comma-separated list of elements we use, and we only use prefLabel and "links" comes with the request
            pagesize: 100
            //suggest: true
        };

        if (selectedOntologies.length > 0) {
            queryParams.ontologies = selectedOntologies.join(','); //It's a very large list of possible ontologies, but examples of a few: ATC, ICD9CM, ICD10, ICDO, LOINC, MEDDRA, MESH, NCIT, RXNORM, SNOMEDCT, WHO-ART
        }

        //https://data.bioontology.org/search?q=hypertension&display_context=false&include=prefLabel&apikey=YOUR_API_KEY
        const response = await axiosInstance.get('https://data.bioontology.org/search', {
            params: queryParams,
            headers: {
                'Authorization': `apikey token=${bioPortalApiKey}`,
                'Accept': 'application/json'
            }
        });
        return response.data.collection; //returns the array of results
    } catch (e) { console.log(e); }
}

const getBioPortalApiKey = async (apiToken, setBioPortalApiKey, setLoadingBioPortalApiKey) => {
    setLoadingBioPortalApiKey(true);
    return await axiosInstance({
        method: 'POST',
        url: fevir_node_server_address,
        timeout: 120000,
        data: {
            'functionid': 'retrieveuserapitoken',
            'apiToken': apiToken,
            'systemname': 'BioPortal'
        },
    })
        .then((resp) => {
            let apitoken = resp?.data?.apitoken;
            if (apitoken) {
                setBioPortalApiKey(apitoken);
                return apitoken;
            }
        })
        .catch((error) => { console.log(error); })
        .finally(() => { setLoadingBioPortalApiKey(false); });
}

const addBioPortalApiKey = async (apiToken, apiKey, setLoadingBioPortalApiKey) => {
    setLoadingBioPortalApiKey(true);
    return await axiosInstance({
        method: 'POST',
        url: fevir_node_server_address,
        timeout: 120000,
        data: {
            'functionid': 'adduserexternalapitokens',
            'apiToken': apiToken,
            'apiTokenPairs': [{ 'systemname': 'BioPortal', 'apitoken': apiKey }]
        },
    })
        .then((resp) => {
            console.log(resp);
            if (resp?.data?.success) {
                return resp?.data?.success;
            }
        })
        .catch((error) => { console.log(error); })
        .finally(() => { setLoadingBioPortalApiKey(false); });
}

const selectResultAsCodeableConcept = (label, code, ontology, ontologyUrl, setCodeableConceptState) => {
    let system = "";
    switch (ontology) {
        case 'SNOMEDCT':
            system = "http://snomed.info/sct";
            break;
        case 'LOINC':
            system = "http://loinc.org";
            break;
        case 'NCIT':
            system = "http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl";
            code = code.replace("Thesaurus.owl#","");
            break;
        case 'RXNORM':
            system = "http://www.nlm.nih.gov/research/umls/rxnorm";
            break;
        case 'ICD10':
            system = "http://hl7.org/fhir/sid/icd-10";
            break;
        case 'ICD11':
            system = "http://id.who.int/icd/release/11/mms";
            break;
        case 'ATC':
            system = "http://www.whocc.no/atc";
            break;
        case 'MESH':
            system = "https://www.nlm.nih.gov/mesh";
            break;
        default:
            system = ontologyUrl;
    }

    setCodeableConceptState(prevState => { return { ...prevState, 'coding': [{ "system": system, "code": code, "display": label }], "text": "" } });
}

const BioPortalResult = ({ result, ontology, setCodeableConceptState, setSearchBioPortalModalState }) => {
    const label = result["label"];
    const code = result["code"];
    const hyperlink = result["hyperlink"];
    const systemUri = result["systemUri"];

    return <div>
        <Button style={{
            color: "#000000", marginLeft: "8px", marginTop: "6px", padding: "6px",
            left: "6px", top: "2px"
        }}
            className="formButton"
            content="SELECT"
            onClick={() => {
                selectResultAsCodeableConcept(label, code, ontology, systemUri,
                    setCodeableConceptState);
                setSearchBioPortalModalState({ modalOpen: false });
            }} />
        <a href={hyperlink} target="_blank" rel="noreferrer noopener" style={{ marginLeft: "6px" }}>
            <b>{label}</b> (<i>{ontology}:</i> {code})
        </a>
    </div>
}

const SearchBioPortalModal = ({ searchBioPortalModalState, setSearchBioPortalModalState,
    setCodeableConceptState }) => {
    const apiToken = useSelector(selectCurrentUserApiToken);
    const [apiKey, setApiKey] = useState(""); //For the text input only
    const [bioPortalApiKey, setBioPortalApiKey] = useState();
    const [loadingBioPortalApiKey, setLoadingBioPortalApiKey] = useState();
    const [loadingSearch, setLoadingSearch] = useState(false);

    const [searchStringState, setSearchStringState] = useState("");

    const [resultsState, setResultsState] = useState();

    const [ontologiesLimitState, setOntologiesLimitState] = useState([]);
    const [sortState, setSortState] = useState(false);

    const addKey = async () => {
        if (apiKey && (await addBioPortalApiKey(apiToken, apiKey.trim(), setLoadingBioPortalApiKey))) {
            setBioPortalApiKey(apiKey.trim());
            //setSearchBioPortalModalState({ modalOpen: false });
        }
    }

    const saveApiKey = () => {
        if (apiKey.trim().length === 36) {
            addKey();
        } else {
            alert("Invalid BioPortal API key, please contact FEvIR Admin if you believe this is a mistake: admin@computablepublishing.com");
        }
    }

    const handleKeyUpSaveApiKey = (event) => {
        if (event.key === 'Enter') {
            saveApiKey();
        }
    }

    const search = async (ontologies = ontologiesLimitState) => {
        setLoadingSearch(true);
        const response = await bioPortalSearch(bioPortalApiKey, searchStringState, ontologies);
        setLoadingSearch(false);
        if (response) {
            let resultsDictionary = {
                "SNOMEDCT": [], "LOINC": [], "RXNORM": [], "MESH": [], "ICD10": [], "ATC": [], "NCIT": []
            };
            for (const result of response) {
                const label = result["prefLabel"];
                const code = result["@id"].substring(result["@id"].lastIndexOf('/') + 1);
                const ontology = result["links"]["ontology"].substring(result["links"]["ontology"].lastIndexOf('/') + 1);
                const hyperlink = result["links"]["ui"];
                const systemUri = result["links"]["ontology"];
                if (ontology) {
                    if (!resultsDictionary[ontology]) {
                        resultsDictionary[ontology] = [];
                    }
                    resultsDictionary[ontology].push({
                        label: label,
                        code: code,
                        hyperlink: hyperlink,
                        systemUri: systemUri
                    });
                }
            }
            if (resultsDictionary.SNOMEDCT.length === 0) {
                delete resultsDictionary.SNOMEDCT;
            }
            if (resultsDictionary.LOINC.length === 0) {
                delete resultsDictionary.LOINC;
            }
            if (resultsDictionary.NCIT.length === 0) {
                delete resultsDictionary.NCIT;
            }
            if (resultsDictionary.RXNORM.length === 0) {
                delete resultsDictionary.RXNORM;
            }
            if (resultsDictionary.MESH.length === 0) {
                delete resultsDictionary.MESH;
            }
            if (resultsDictionary.ICD10.length === 0) {
                delete resultsDictionary.ICD10;
            }
            if (resultsDictionary.ATC.length === 0) {
                delete resultsDictionary.ATC;
            }
            setResultsState(resultsDictionary);
        }
    }

    const handleKeyUpSearch = async (event) => {
        if (event.key === 'Enter') {
            search();
        }
    }

    useEffect(() => {
        if (apiToken && !bioPortalApiKey && !loadingBioPortalApiKey) {
            getBioPortalApiKey(apiToken, setBioPortalApiKey, setLoadingBioPortalApiKey);
            //TODO: Then something to check to make sure it's a valid API Key, if it's not valid then tell the user and show the BioPortal API Key text field again
        }
    }, [apiToken]);

    useEffect(() => { }, [sortState]);

    const modalContent = <Modal.Content style={{ paddingTop: "12px", textAlign: "left" }}>
        {(loadingBioPortalApiKey || loadingSearch) &&
            <Dimmer className={"loadingDimmer"} active inverted>
                <Loader inverted>Loading</Loader>
            </Dimmer>
        }
        <h2>BioPortal Search</h2>
        <br />
        <Button style={{ padding: "6px", position: "absolute", top: "6px", right: "2px" }}
            className="formButton negative"
            content="✖"
            onClick={() => {
                setSearchBioPortalModalState({ modalOpen: false });
            }} />
        {loadingBioPortalApiKey === false && (!bioPortalApiKey || bioPortalApiKey.length < 36) ?
            <>
                <b>Enter your BioPortal API Key from your BioPortal account page:</b>
                <br />
                <TextField style={{ width: "70%", marginTop: "4px", marginBottom: "8px" }} className="inputField" type='text' label={'BioPortal API Key'} size="small" variant='outlined' value={apiKey} onChange={(e) => { setApiKey(e.target.value); }} onKeyUp={handleKeyUpSaveApiKey} />
                <Button style={{ marginLeft: "8px", marginTop: "6px", padding: "6px", left: "6px", top: "2px" }}
                    className="formButton positive"
                    content="Save"
                    onClick={saveApiKey}
                    onKeyUp={handleKeyUpSaveApiKey}
                />
                <br />
                If you don't have a BioPortal account, you can make one here: <a href="https://bioportal.bioontology.org/accounts/new">https://bioportal.bioontology.org/accounts/new</a>. If you have a BioPortal account, log in at <a href="https://bioportal.bioontology.org/login">https://bioportal.bioontology.org/login</a>, then click on Account Settings in the dropdown menu in the upper right, then yuo can copy your API Key. You are responsible for respecting the license terms that you agreed to for your use of BioPortal when you use it through the FEvIR Platform.
            </>
            :
            <>
                <p>You are responsible for respecting the license terms that you agreed to for your use of BioPortal when you use it through the FEvIR Platform. <i>After SELECTing a result, to see your changes in the content, either <b>Save All Changes</b> or go to the <b>JSON View</b> then return to the <b>Text View</b>.</i></p>
                <TextField style={{ width: "80%", marginBottom: "8px" }} className="inputField" type='text' label={'BioPortal Search Query'} size="small" variant='outlined' value={searchStringState} onChange={(e) => { setSearchStringState(e.target.value); }} onKeyUp={handleKeyUpSearch} />
                <Button style={{ marginLeft: "8px", marginTop: "6px", padding: "6px", left: "6px", top: "2px" }}
                    className="formButton positive"
                    content="Search"
                    onClick={() => { search(); }} />

                <Dropdown
                    name="Ontology"
                    placeholder="Ontology"
                    className="ontologyDropdown"
                    search={true}
                    closeOnChange selection clearable selectOnBlur={false} autoComplete='off'
                    options={ontologyOptions}
                    value={ontologiesLimitState?.[0] || null}
                    onChange={(e, data) => {
                        setOntologiesLimitState(prevState => {
                            return [data.value];
                        });
                        if (resultsState) { //If results are already being show
                            search([data.value]); //re-run the search //sending it data.value because setting a state isn't instantaneous
                        }
                    }}
                />
                <Button name="Sort" content="Sort"
                    onClick={() => { setSortState(!sortState) }} />
                {resultsState && <div style={{ wordBreak: "break-word" }}>
                    {Object.keys(resultsState).length > 0 ?
                        <> {Object.keys(resultsState).map((ontology, index) => {
                            if (sortState === true) {
                                return <div key={index} style={{ marginBottom: "20px" }}>
                                    <div>from {ontology}</div>
                                    {resultsState[ontology]
                                        .toSorted((a, b) => {
                                            if (a.label.toLowerCase() > b.label.toLowerCase()) {
                                                return 1
                                            } else {
                                                return -1
                                            }
                                        })
                                        .map((result, resultIndex) => {
                                            return <BioPortalResult result={result} ontology={ontology} key={resultIndex}
                                                setCodeableConceptState={setCodeableConceptState}
                                                setSearchBioPortalModalState={setSearchBioPortalModalState} />
                                        }
                                        )}
                                </div>
                            } else {
                                return <div key={index} style={{ marginBottom: "20px" }}>
                                    <div>from {ontology}</div>
                                    {resultsState[ontology].map((result, resultIndex) => {
                                        return <BioPortalResult result={result} ontology={ontology} key={resultIndex}
                                            setCodeableConceptState={setCodeableConceptState}
                                            setSearchBioPortalModalState={setSearchBioPortalModalState} />
                                    }
                                    )}
                                </div>
                            }
                        })}</>
                        :
                        <h4>No results.</h4>}
                </div>}
            </>
        }
    </Modal.Content>

    return <Modal
        style={{ padding: "0px", margin: "0px", width: "75%", height: "95%", overflowY: "scroll" }}
        dimmer={<Modal.Dimmer style={{ backgroundColor: "#00000077" }} />}
        open={searchBioPortalModalState.modalOpen}
        centered={false}
        content={modalContent}
    />
}

export default SearchBioPortalModal;